import { Link } from 'react-router-dom';
import { ApolloError } from '@apollo/client';
import { ReactNode } from 'react';

import { Page } from '@occc-app/design-system';
import {
  AddIcon,
  TableContainer,
  Button,
  TableHeader,
  IPaginationProps,
} from '@occc/ui-design-system';
import { RetailerNetworkPartialFragment } from '@occc/graphql';
import config from '@occc/config';
import { Can } from '@occc-app/App/PolicyBasedAccessControl';
import { CreateRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkListTable } from './components/retailer-network-list-table.component';

import { routeCreator } from '../retailer-connect.utils';

const PAGE_TITLE = `${config.brandName} Retailer Networks`;

type RetailerNetworkListPageProps = {
  loading: boolean;
  error?: ApolloError;
  data?: RetailerNetworkPartialFragment[];
  paginationProps: IPaginationProps;
  tableActions: ReactNode;
  onNetworkClick?: (uuid: string) => void;
  pageSubtitle?: string;
};

export const RetailerNetworkListPage = ({
  loading,
  error,
  data,
  paginationProps,
  tableActions,
  onNetworkClick,
  pageSubtitle,
}: RetailerNetworkListPageProps) => {
  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      actions={
        <Can I={CreateRetailerNetwork()}>
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            startIcon={<AddIcon />}
            to={routeCreator.configurationNetworkDetails}
            role='button'
          >
            Add New Network
          </Button>
        </Can>
      }
      pageHeaderProps={{
        title: PAGE_TITLE,
        subtitle: pageSubtitle,
      }}
      containerProps={{ variant: 'md' }}
    >
      <TableContainer>
        <TableHeader title={PAGE_TITLE} actions={tableActions} />
        <RetailerNetworkListTable
          data={data}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
          onNetworkClick={onNetworkClick}
        />
      </TableContainer>
    </Page>
  );
};
